module.exports = __webpack_public_path__ + "static/media/BLZD.fdf1fc8d.png";